import { render, staticRenderFns } from "./Anular.vue?vue&type=template&id=6f07d0a6&scoped=true"
import script from "./Anular.vue?vue&type=script&lang=js"
export * from "./Anular.vue?vue&type=script&lang=js"
import style0 from "./Anular.vue?vue&type=style&index=0&id=6f07d0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07d0a6",
  null
  
)

export default component.exports